import React, { useEffect, useState, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  brandMention,
  createHOst,
  deleteIp,
  brandMentionAction,
  brandMentionAdd
} from "../../actions/inventory";
import { Link, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "../Pagination/Pagination";
import moment from "moment";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import $ from "jquery";
import { toastr } from "react-redux-toastr";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import Fancybox from "../../utils/Fancybox";
import {
  takeDown
} from "../../actions/look-alike";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { API_URL } from "../../utils/constant";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Modal } from "react-bootstrap";
import { rescanSingle } from "../../actions/users";



function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
  },
  paper: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
    minWidth: "600px",
    minHeight: "300px",
  },
}));

const tableStyles = {
  table: {
    width: '100%',
    tableLayout: 'fixed',
  },
  td: {
    padding: '8px',
    verticalAlign: 'top',
    wordBreak: 'break-word',
    maxWidth: '33%',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
};

const AssetDiscovery = () => {
  const dispatch = useDispatch();
  const myRef = useRef(null);
  const [isModal, setModal] = useState(false);
  const [isModalTwo, setModalTwo] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [modalHeading, setModalHeading] = useState("");
  const [modalBody, setModalBody] = useState([]);

  const [applyCountrySearch, setApplyCountrySearch] = useState([]);
  const [applyCloudSearch, setApplyCloudSearch] = useState([]);

  const [certModal, setCertModal] = useState(false);
  const [certModalBody, setCertModalBody] = useState();

  const [page, setPage] = useState(1);
  const [firstLoad, setFirstLoad] = useState(true);
  const [PageSize, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [filterData, setfilterData] = useState("all");
  const [addIpModel, setAddIpModel] = useState(false);
  const [modalStyle] = useState(getModalStyle);
  const [addHost, setHost] = useState("");
  const classes = useStyles();
  const [ipRemoveModal, setIpRemoveModal] = useState(false);
  const [ipId, setIpId] = useState("");
  const [limit, setLimit] = useState(10);
  const [isTakeDownModal, setTakeDownModal] = useState("");
  const [modalDetailsOne, setModalDetailsOne] = useState("");
  const [modalDetailsTwo, setModalDetailsTwo] = useState("");
  const [modalDetailsDataOne, setModalDetailsDataOne] = useState("");
  const [modalDetailsDataTwo, setModalDetailsDataTwo] = useState("");
  const [stolenLocation, setStolenLocation] = useState("");
  const [contenSource, setContenSource] = useState("");
  const [infringingIp, setInfringingIp] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const [rowId, setRowId] = useState("");
  const [subject, setSubject] = useState("");
  const [category, setCategory] = useState("all");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const queryParameters = new URLSearchParams(window.location.search)
  const latest = queryParameters.get("latest");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [userComment, setUserComment] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const fileInputRef = useRef(null);
  const [isAddBrandMentionModal, setAddBrandMentionModal] = useState(false);
  const [lookalike, setLookalike] = useState("");
  const [original, setOriginal] = useState("");
  const [fuzzer, setFuzzer] = useState("typo");
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [seoData, setSeoData] = useState(null);
  
  const auth = useSelector(
    (state) => state?.auth?.user
  );
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.bs?.e;
  });


  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const client = useSelector(
    (state) =>
      state?.summary?.localClient || state?.summary?.clients?.[0]
  );


  let domains = "";
  client?.domains?.forEach((row) => {
    domains += "," + row
  })
  // latest
  let table = useSelector((state) => state?.inventory?.brand);
  let rating = useSelector((state) => state?.inventory?.brand?.individualRating);
  const scanCompleted = useSelector((state) => state.inventory.scanCompleted);

  useEffect(() => {
    const delayedSearch = setTimeout(() => {
      brandMention(id, dispatch, page, category, search, limit);
    }, 500);

    return () => clearTimeout(delayedSearch);
  }, [search, id, page, category, dispatch, limit]);

  useEffect(() => {
    setTotalItems(table?.totalCount)
  }, [table?.totalBrandMentions])

  const createHost = () => {
    let host = $("#hostName").val();
    if (!host) {
      toastr.error("Error", "Please enter host address.");
      return false;
    }
    createHOst({ organisationId: id, ip: host }, dispatch);
  };

  const modalBodyData = (
    <div style={modalStyle} className={classes.paper}>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
        }}
      >
        <button
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => setAddIpModel(false)}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div>
        <h2>Add Targets</h2>
        <div>
          <div className="row">
            <label className="col-form-label col-md-4">Host Name</label>
            <div className="col-md-7">
              <input
                type="text"
                className="form-control"
                // style={{ width: 200 }}
                id="hostName"
                placeholder="Add Host"
                value={addHost}
                onChange={(e) => setHost(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="text-right mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={() => createHost()}
                >
                  Add Host
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );


  const handleEditorChange = (even, editor) => {
    const data = editor.getData();
    setEditorContent(data); // Update the state with the new content
  };


  const submitTakeDownValue = async () => {
    if (userComment == "") {
      toastr.error("Error", "Comment cannot be empty.");
      return false;
    }

    try {
      setTakeDownModal(false);
      
      // Create FormData for file upload
      const formData = new FormData();
      formData.append('organisationId', id);
      formData.append('recordId', rowId);
      formData.append('userComment', userComment);
      formData.append('moduleName', 'lookalike');
      
      // Add file if uploaded
      if (uploadedFile) {
        formData.append('file', uploadedFile);
      }

      // Call takeDown API with FormData
      const response = await takeDown(formData, dispatch);
      
      // Refresh the SEO poisoning data after successful takedown
      if (response && !response.error) {
        const session = localStorage.getItem("session");
        const seoResponse = await axios.get(
          `${API_URL}/seo-poisoning/${id}/delta?page=${page}&limit=${limit}&category=${category}&subDomain=${search}`,
          {
            headers: {
              Authorization: `Bearer ${session}`
            }
          }
        );
        
        if (seoResponse.data.error === false) {
          setSeoData(seoResponse.data.data);
          setTotalItems(seoResponse.data.data.seoPoisoning.length);
        }
      }
      
      // Reset the form fields
      setUserComment("");
      setUploadedFile(null);
      setFilePreview(null);
      // Clear file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      console.error("Error submitting takedown request:", error);
      toastr.error("Error", error.response?.data?.userMessage || "Failed to submit takedown request");
    }
  };

  // Handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        toastr.error("Error", "File size must be less than 10MB");
        e.target.value = null;
        return;
      }
      
      setUploadedFile(file);
      
      // Create preview for images
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setFilePreview(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        setFilePreview(null);
      }
    }
  };

  const takeDownValue = (res) => {
    let ip;
    res?.dnsDetails?.map((row) => {
      return Object.keys(row || {}).map((key) => {
        let record = row[key];
        if (record && record.length == 0) return false;
        if (key !== "dns_a") return false;
        record?.map((val) => {
          ip = val;
        });
      });
    });
    let originalWebsite = client.website;
    let domainName = res.host;
    ip = res.ip;
    setStolenLocation(originalWebsite);
    setContenSource(domainName);
    setInfringingIp(ip);
    setRowId(res._id);
    setUserComment("");
    setUploadedFile(null);
    setFilePreview(null);
    // Clear file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setTakeDownModal(true);
  };


  const exportToCSVNew = (fileName) => {
    const downloadExcel = Object.keys(modalBody).map((val) => {
      let value = modalBody[val];
      if (fileName == "Hosts Location") {
        return {
          HostsLocation: val?.replace(/['"]+/g, ""),
          IP: JSON.stringify(value.map((res) => res))
            ?.replace(/[\[\]']+/g, "")
            ?.replace(/['"]+/g, ""),
        };
      } else if (fileName == "Cloud / ISP Provider") {
        return {
          CloudProvider: val?.replace(/['"]+/g, ""),
          IP: JSON.stringify(value.map((res) => res))
            ?.replace(/[\[\]']+/g, "")
            ?.replace(/['"]+/g, ""),
        };
      } else if (fileName == "Network Services") {
        return {
          NetworkServices: val?.replace(/['"]+/g, ""),
          IP: JSON.stringify(value.map((res) => res))
            ?.replace(/[\[\]']+/g, "")
            ?.replace(/['"]+/g, ""),
        };
      }
    });

    const ws = XLSX.utils.json_to_sheet(downloadExcel);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(data, fileName + ".xlsx");
  };

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/brand-mentions/${id}/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Brand Mention.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  let currentTableData = [];

  currentTableData = table;


  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const addModal = () => {
    setModalTwo("Form Wizard modal two");
  };

  const multicheck = (data) => {
    const allIds = data?.map((item) => item?._id);
    if (selectedIds?.length > 0 || selectedIds?.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };


  const singleClick = (id) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event, name) => {
    if (event == "markAsRemidiated") {
      const data = {
        action: "markAsRemidiated",
        brandMentionIds: selectedIds == 0 ? _id : selectedIds,
        actionNote: "",
        for: "forever",
      };
      brandMentionAction(
        id,
        dispatch,
        page,
        category,
        search,
        data
      );
      setSelectedValue("pleaseSelect");
      setActionNote("");
      setSelectedIds([]);
    }
  };

  const Unsnoozed = (_id) => {
    const data = {
      action: "resetAction",
      brandMentionIds: selectedIds == 0 ? [ _id] : selectedIds,
    };
    brandMentionAction(
      id,
      dispatch,
      page,
      category,
      search,
      data
    );
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      brandMentionIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue
    };
    brandMentionAction(
      id,
      dispatch,
      page,
      category,
      search,
      data
    );
    setModalTwo("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  const reScan = () => {
    let data = {
      "moduleName": ["brandMentions"]
    }
    rescanSingle(id, data)
  }

  const handleAddBrandMention = () => {
    if (!lookalike) {
      toastr.error("Error", "Lookalike domain is required.");
      return false;
    }
    
    const payload = {
      organisationId: id,
      host: lookalike,
      updatedAt: new Date().toISOString()
    };
    
    brandMentionAdd(payload);
    
    // Reset form fields and close modal
    setLookalike("");
    setOriginal("");
    setFuzzer("typo");
    setAddBrandMentionModal(false);
  };

  // Add new useEffect for fetching dashboard data
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const session = localStorage.getItem("session");
        const response = await axios.get(
          `${API_URL}/getDashboardDetailsV1/${id}?page=Brand&top_issues=all`,
          {
            headers: {
              Authorization: `Bearer ${session}`
            }
          }
        );
        setDashboardData(response.data);
        setLoading(false);
      } catch (error) {
        // console.error removed
        setLoading(false);
        toastr.error("Error", "Failed to fetch dashboard data");
      }
    };

    if (id) {
      fetchDashboardData();
    }
  }, [id]);

  // Update useEffect for fetching SEO poisoning data
  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        setLoading(true);
        const session = localStorage.getItem("session");
        const response = await axios.get(
          `${API_URL}/seo-poisoning/${id}/delta?page=${page}&limit=${limit}&category=${category}&subDomain=${search}`,
          {
            headers: {
              Authorization: `Bearer ${session}`
            }
          }
        );
        if (response.data.error === false) {
          setSeoData(response.data.data);
          setTotalItems(response.data.data.seoPoisoning.length);
        } else {
          toastr.error("Error", response.data.userMessage || "Failed to fetch data");
        }
        setLoading(false);
      } catch (error) {
        // console.error removed
        setLoading(false);
        toastr.error("Error", "Failed to fetch SEO poisoning data");
      }
    };

    if (id) {
      fetchSeoData();
    }
  }, [id, page, limit, category, search]);

  return (
    <div className="container-fluid">
      <AccessPage></AccessPage>
      <Modal
        open={addIpModel}
        onClose={() => setAddIpModel(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {modalBodyData}
      </Modal>
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Seo Poisoning </h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }
                <li className="breadcrumb-item active" aria-current="page" style={{ color: 'white' }}>
                Seo Poisoning
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      {typeof scanCompleted !== "undefined" && !scanCompleted && (
        <div className="card border-success">
          <ScanMessage />
        </div>
      )}

      <div className="row clearfix">
        <div className="col-lg-12 col-md-12">
          <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
            <li className="nav-item">
              <a
                className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                  }`}
                onClick={() => {
                  setCategory("all");
                  setPage(1);
                  setSearch("");
                  setSelectedIds([]);
                }}
              >
                Current
              </a>
            </li>
          </ul>
          <div className="card card_tableBox">
            <div className="body">
              <div className="header">
                <div className="row clearfix">
                  <div className="col-sm-3 mb-2">
                    
                  </div>
                  <div className="col-sm-3 mb-2">
                    {selectedIds.length > 1 && userPermission && category === "all" && (
                      <Box sx={{ width: 160 }}>
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedValue}
                            onChange={(event) => {
                              setAction(event.target.value);
                              snooze("", event.target.value);
                            }}
                          >
                            <MenuItem value="pleaseSelect">
                              Snooze Options
                            </MenuItem>
                            <MenuItem
                              value="riskAccepted"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              Risk Accepted
                            </MenuItem>
                            <MenuItem
                              value="markAsFalsePositive"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              False Positive
                            </MenuItem>
                            <MenuItem value="markAsRemidiated">
                              Remediated
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    )}
                    {selectedIds.length > 1 && userPermission &&
                      (category == "false-positive" ||
                        category == "risk-accepted") && (
                        <button
                          className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                          onClick={() => Unsnoozed("")}
                        >
                          Unsnooze
                        </button>
                      )}
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-custom spacing5 mb-0">
                    <thead>
                      <tr>
                       
                        <th>Domain</th>
                        <th>Title</th>
                        <th>Keywords</th>
                        </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6" className="text-center">Loading...</td>
                        </tr>
                      ) : seoData?.seoPoisoning?.map((row) => (
                        <tr key={row._id}>
                          
                          <td>
                            <a href={row.Url} target="_blank" rel="noopener noreferrer">
                              {row.Url}
                            </a>
                          </td>
                          <td>
                            <span>
                              {row?.Title || 'N/A'}
                            </span>
                          </td>
                          <td>
                            <span>
                              {row?.Keywords || 'N/A'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="dataTables_paginate">
                    {totalItems > 0 && (
                      <Pagination
                        className="pagination-bar"
                        currentPage={page}
                        totalCount={totalItems}
                        pageSize={limit}
                        onPageChange={(page) => setPage(page)}
                      />
                    )}
                  </div>
                  {totalItems > 10 && (
                    <select
                      value={limit}
                      onChange={(e) => {
                        setLimit(e.target.value)
                      }}
                      className="form-control limitSelectBox"
                    >
                      <option value={10}>10 per page</option>
                      <option value={25}>25 per page</option>
                      <option value={50}>50 per page</option>
                      <option value={100}>100 per page</option>
                    </select>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="col-lg-4 col-md-12">
          <div className="card user_statistics">
            <div className="body" style={{ height: "400px" }}>
              <span>Previous scan details</span>
              {scanDetails && (
                <BasicLineColumn
                  dates={scanDetails?.dates}
                  // openPortArray={openPortArray}
                  ipArray={ipArray}
                  color={["#008ffb", "#00e396"]}
                  yAxis="IP Discovered"
                />
              )}
            </div>
          </div>
        </div> */}
      </div>

      <div
        className={`modal fade Form-Wizard-modal ${isModal ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg assetsDiscoveryModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {modalHeading}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page">
              <div id="wizard_horizontal">
                <section>
                  <div className="row">
                    <div className="col-sm-12">
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          exportToCSVNew(modalHeading);
                        }}
                        href="/add-report"
                        style={{ float: "right" }}
                        className="btn btn-primary mr-1"
                      >
                        <i className="fa fa-file-excel-o"></i>
                      </a>
                    </div>
                  </div>
                  <div className="card">
                    {/* <div className="body"> */}
                    <div className="table-responsive">
                      <table className="table table-hover table-custom spacing5">
                        <thead>
                          <tr>
                            {Object.keys(modalBody).map((val) => {
                              return (
                                <th style={{ width: "200" }}>
                                  {val?.replace(/['"]+/g, "")}
                                </th>
                              );
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {Object.keys(modalBody).map((val) => {
                              let value = modalBody[val];
                              return (
                                <td style={{ verticalAlign: "top" }}>
                                  {value?.map((row) => {
                                    return (
                                      <>
                                        <span>{row}</span>
                                        <br />
                                      </>
                                    );
                                  })}
                                </td>
                              );
                            })}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* </div> */}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`modal fade Form-Wizard-modal ${certModal ? "d-block show" : ""
        }`}>
        <div className="modal-dialog modal-lg assetsDiscoveryModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Certificate
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setCertModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page">
              <div id="wizard_horizontal">
                <section>
                  <div className="card" dangerouslySetInnerHTML={{ __html: certModalBody?.replace(/\n/g, "<br />") }}>
                    {/* {certModalBody}
                    dangerouslySetInnerHTML={{__html: alert.alertContent}} */}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade  ${ipRemoveModal ? "d-block show" : ""}`}
        id="exampleModal"
        onClick={() => setIpRemoveModal(false)}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Delete
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-round btn-default"
                data-dismiss="modal"
                onClick={() => setIpRemoveModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-round btn-primary"
                onClick={() => {
                  deleteIp(ipId, id, true, dispatch);
                  setIpRemoveModal(false);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade Form-Wizard-modal ${isTakeDownModal ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Website Takedown Request
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setTakeDownModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="card card_ck">
                    <div className="body">
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Comment <span className="text-danger">*</span></label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setUserComment(e.target.value)}
                            value={userComment}
                            className="form-control"
                            rows="3"
                            required
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Upload File (Optional)</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <input
                            ref={fileInputRef}
                            type="file"
                            className="form-control"
                            onChange={handleFileChange}
                            accept="image/*,.pdf,.doc,.docx"
                          />
                          <small className="form-text text-muted">
                            Accepted formats: Images, PDF, DOC, DOCX (Max 10MB)
                          </small>
                        </div>
                        {filePreview && (
                          <div className="form-group col-lg-12 col-md-12">
                            <img 
                              src={filePreview} 
                              alt="Preview" 
                              style={{ maxWidth: '100%', maxHeight: '200px', marginTop: '10px' }}
                            />
                          </div>
                        )}
                        {uploadedFile && !filePreview && (
                          <div className="form-group col-lg-12 col-md-12">
                            <div className="alert alert-info">
                              <i className="fa fa-file"></i> {uploadedFile.name} ({(uploadedFile.size / 1024 / 1024).toFixed(2)} MB)
                            </div>
                          </div>
                        )}
                        {uploadedFile && (
                          <div className="form-group col-lg-12 col-md-12">
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => {
                                setUploadedFile(null);
                                setFilePreview(null);
                                // Clear file input
                                if (fileInputRef.current) {
                                  fileInputRef.current.value = '';
                                }
                              }}
                            >
                              <i className="fa fa-trash"></i> Remove File
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <button
                          className="btn btn-default btn-sm mr-1 pull-right"
                          style={{ marginTop: "10px" }}
                          onClick={() => {
                            setTakeDownModal(false);
                            setUserComment("");
                            setUploadedFile(null);
                            setFilePreview(null);
                            // Clear file input
                            if (fileInputRef.current) {
                              fileInputRef.current.value = '';
                            }
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary btn-sm mr-1 pull-right"
                          style={{ marginTop: "10px" }}
                          onClick={() => submitTakeDownValue()}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade Form-Wizard-modal ${modalDetailsOne ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Brand Impersonation Analysis
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setModalDetailsOne(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <table className="table table-responsive">
                    <thead>
                      <tr>
                        <th>Conclusion</th>
                        <th>Mention Type</th>
                        <th>Mentions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-wrap">
                          {modalDetailsDataOne?.conclusion || "N/A"}
                        </td>
                        <td>
                          {modalDetailsDataOne?.mention_type || "N/A"}
                        </td>
                        <td className="text-wrap">
                          {modalDetailsDataOne?.mentions && Array.isArray(modalDetailsDataOne.mentions)
                            ? modalDetailsDataOne.mentions.map((r, index) => (
                              <span key={index}>{r || "N/A"}</span>
                            ))
                            : "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade Form-Wizard-modal ${modalDetailsTwo ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Suspected Website Analysis
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setModalDetailsTwo(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <table className="table table-responsive">
                    <thead>
                      <tr>
                        <th>Url</th>
                        <th>Full Page Screenshot</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <a href={modalDetailsDataTwo?.url} target="_blank">
                            {modalDetailsDataTwo?.url || "N/A"}
                          </a>
                        </td>
                        <td>
                          {modalDetailsDataTwo?.full_page_screenshot ?
                            <Fancybox
                              options={{
                                Carousel: {
                                  infinite: false,
                                },
                              }}
                            >
                              <a
                                data-fancybox="gallery"
                                href={modalDetailsDataTwo?.full_page_screenshot}
                              >
                                <img
                                  alt=""
                                  src={modalDetailsDataTwo?.full_page_screenshot}
                                  style={{
                                    width: '100px',
                                    height: '100px',
                                    objectFit: 'cover'
                                  }}
                                />
                              </a>
                            </Fancybox>
                            : "N/A"}
                        </td>
                        <td className="text-wrap">
                          {modalDetailsDataTwo?.description || "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModalTwo === "Form Wizard modal two" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {action == "markAsFalsePositive"
                  ? "Mark As False Positive"
                  : "Risk Accepted"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModalTwo("");
                  setActionNote("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page modal_mob">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <label className="col-lg-6 col-md-12">Snooze for</label>
                      <div className="form-group ol-lg-12 col-md-12">
                        <select
                          className="custom-select custom-select-sm form-control form-control-sm"
                          onChange={(e) => setForValue(e.target.value)}
                        >
                          <option value="forever">Forever</option>
                          <option value="3 months">3 Months</option>
                          <option value="6 months">6 Months</option>
                          <option value="12 months">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="col-lg-12 col-md-12">Detail</label>
                      <div className="form-group col-lg-12 col-md-12">
                        <textarea
                          onChange={(e) => setActionNote(e.target.value)}
                          value={actionNote}
                          className="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12"
                      style={{ marginRight: "28px" }}
                    >
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={submit}
                        className="btn btn-round btn-primary mr-1 pull-right"
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => {
                          setModalTwo("");
                          setActionNote("");
                        }}
                        className="btn btn-round btn-default pull-right"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`modal fade Form-Wizard-modal ${isAddBrandMentionModal ? "d-block show" : ""}`}>
        <div className="modal-dialog modal-lg" id="addBrandMentionModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Brand Mention</h5>
              <button
                type="button"
                className="close"
                onClick={() => setAddBrandMentionModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="card mb-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Domain Host <span className="text-danger">*</span></label>
                        <input 
                          type="text" 
                          className="form-control"
                          value={lookalike}
                          onChange={(e) => setLookalike(e.target.value)}
                          placeholder="Enter domain host (e.g., example.com)"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  
                  <div className="row mt-3">
                    <div className="col-md-12 text-right">
                      <button 
                        className="mr-2 btn btn-round btn-default"
                        onClick={() => setAddBrandMentionModal(false)}
                      >
                        Cancel
                      </button>
                      <button 
                        className="btn btn-primary"
                        onClick={handleAddBrandMention}
                      >
                        Add Brand Mention
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AssetDiscovery;
